import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import { IdProps } from '../../../types/IdProps';

const ProductCategory_tab_SubCategories: React.FC<IdProps> = ({ id }) => {
    const [data, setData] = useState<[]>();
    const { handleException } = useNotifications();

    useEffect(() => {
        getTableData();
    }, [id]);

    function getTableData() {
        DataService.get<[]>('api/v1/ProductCategories/ByParentProductCategory/' + id)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    return (
        <DataTable
            name='dtSubCategories'
            colInfos={[
                { key: true, dataProp: 'Id', visible: false },
                { title: 'Name', dataProp: 'name' },
                { title: 'Abbr.', dataProp: 'abbreviation' },
                { title: 'Name tree', dataProp: 'nameTree', sort: 'asc' }
            ]}
            tableData={data}
            navigateTitle='Product category'
            navigateUrl='/plm/ItemSetup/ProductCategory/'
        />
    );
}
export default ProductCategory_tab_SubCategories;